import { createContext, useContext } from 'react';

import type { FlyoverPlaybackState } from '../types';

export interface FlyoverContextType {
  playbackState: FlyoverPlaybackState;
  playbackSpeedMultiplier: number;
  setPlaybackSpeedMultiplier: (multiplier: number) => void;
  progress: number;
  setProgress: (progress: number) => void;
  pause: () => void;
  resume: () => void;
  restart: () => void;
  userAgent?: string;
}

export const FlyoverContext = createContext<FlyoverContextType | undefined>(
  undefined
);

export const useFlyoverState = (): FlyoverContextType => {
  const context = useContext(FlyoverContext);

  if (!context) {
    throw new Error(
      'useFlyoverState must be used within the Flyover component'
    );
  }
  return context;
};
